import { Download, Play } from "lucide-react";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { PayrollRunStatusBadge } from "@/payroll/pay-periods/payroll-run-status-badge";
import { PayrollRunStatus } from "@/payroll/payroll.d";

interface AiScriptRunStateProps {
  title: string;
  action: "run" | "download";
  status?: PayrollRunStatus | null;
  isLoading?: boolean;
  disabledReason?: string;
  onAction: () => void;
}

export const AiScriptRunState = ({
  title,
  action,
  status,
  isLoading = false,
  disabledReason,
  onAction,
}: AiScriptRunStateProps) => {
  const isDownloadAction = action === "download";
  const isRunDisabled = !isDownloadAction && (isLoading || !!disabledReason);

  return (
    <Stack
      fullWidth
      justify="center"
      align="center"
      className="h-[300px]"
      gap="md"
    >
      {status && <PayrollRunStatusBadge status={status} />}
      <Typography variant="titleW3">{title}</Typography>
      {!isDownloadAction && disabledReason && (
        <Typography variant="bodyW3" textColor="secondary">
          {disabledReason}
        </Typography>
      )}
      <Button
        variant="default"
        size="sm"
        leftIcon={
          isDownloadAction ? <Download className="h-4 w-4" /> : undefined
        }
        onClick={onAction}
        disabled={isRunDisabled}
        loading={isDownloadAction ? isLoading : undefined}
      >
        {isDownloadAction ? (
          "Download result"
        ) : (
          <>
            {isLoading ? (
              <LoadingSpinner
                size="sm"
                containerClassName="w-fit"
                color="tertiary"
              />
            ) : (
              <Play className="h-4 w-4" />
            )}
            Run Payroll
          </>
        )}
      </Button>
    </Stack>
  );
};
